import { render, staticRenderFns } from "./FooterOutro.vue?vue&type=template&id=23918a44&"
import script from "./FooterOutro.vue?vue&type=script&lang=js&"
export * from "./FooterOutro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports